export const searchAPI = '//booksearch.delbanco.de/life/searchapi2.php';



// WEBPACK FOOTER //
// ./src/js/settings.js